<template>
    <div class="index_box">
        <v-header></v-header>
        <v-query-box @queryData="querydata" @tabFun="tabFun"></v-query-box>
        <div class="index_title">
            <span class="fr" @click="goPage('/ipBackups')">查看更多<i class="el-icon-arrow-right"></i></span>
            <img class="imgClass" src="https://zyprogram.xinchacha.com/xiansuo/pc/beian.png" alt="" srcset="">IP报备单位名称
        </div>
        <index-table></index-table>
        <!-- <div class="index_title">
            <img class="imgClass" src="https://zyprogram.xinchacha.com/xiansuo/pc/beianshujv.png" alt="" srcset="">备案数据分析
        </div> -->
        <div style="width:100%;height:40px"></div>
        <v-modular-five></v-modular-five>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vHeader from './common/header.vue'
import vFooter from './common/footer.vue'
import vQueryBox from './common/query_box.vue'
import indexTable from './modular/index_table.vue'
import vModularFive from './modular/modular_five.vue'
export default {
    data(){
        return{
            showType:1,
            queryStr:'',
            upLoadObj:{
                type:1,
                queryStr:''
            }
        }
    },
    components:{
        vHeader,
        vQueryBox,
        indexTable,
        vModularFive,
        vFooter
    },
    methods:{
        goPage(url){
            return this.$router.push({
                path:url
            });
        },
        querydata(data){
            this.upLoadObj = {
                type:data.tableType,
                queryStr:data.queryStr
            }
            if (parseInt(data.tableType) == 1) {
                return this.$router.push({
                    path:'/wordsList',
                    query:{
                        text:data.queryStr
                    }
                });
            }else if (parseInt(data.tableType) == 2){
                return this.$router.push({
                    path:'/emptyshell',
                    query:{
                        text:data.queryStr
                    }
                });
            }else if(parseInt(data.tableType) == 4){
                //
                return this.$router.push({
                    path:'/company_check',
                    query:{
                        text:data.queryStr
                    }
                });
            }
        },
        tabFun(val){
            this.showType = parseInt(val);
            console.log(val)
        }
    },
    mounted(){
    }
}
</script>
<style scoped>

</style>
<style lang="scss" scoped>
.fr{
    float: right;
}
.index_box{
    width: 100%;
    height: auto;
    background-color: #F0F2F5;
}

.index_title{
    height: 60px;
    line-height: 60px;
    margin: 20px auto 20px;
    font-size: 26px;
    color: #333333;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >img.imgClass{
        width: 30px;
        height: auto;
        vertical-align: middle;
        margin-right: 20px;
    }
    >span.fr{
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        background: #4192FE;
        border-radius: 20px;
        font-weight: 400;
        color: #fff;
        padding: 0 20px;
        display: inline-block;
        margin-top: 10px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/index.vue